module.exports = __webpack_public_path__ + "img/17_icon.51010dd5.png";